/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { InstructionCard } from './InstructionCard'
import {
  InstructionCardFromJSON,
  InstructionCardFromJSONTyped,
  InstructionCardToJSON,
} from './InstructionCard'

/**
 *
 * @export
 * @interface GetInstructions200ResponseData
 */
export interface GetInstructions200ResponseData {
  /**
   * Карточки инструкций
   * @type {Array<InstructionCard>}
   * @memberof GetInstructions200ResponseData
   */
  instructions: Array<InstructionCard>
}

/**
 * Check if a given object implements the GetInstructions200ResponseData interface.
 */
export function instanceOfGetInstructions200ResponseData(
  value: object
): value is GetInstructions200ResponseData {
  if (!('instructions' in value) || value['instructions'] === undefined)
    return false
  return true
}

export function GetInstructions200ResponseDataFromJSON(
  json: any
): GetInstructions200ResponseData {
  return GetInstructions200ResponseDataFromJSONTyped(json, false)
}

export function GetInstructions200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetInstructions200ResponseData {
  if (json == null) {
    return json
  }
  return {
    instructions: (json['instructions'] as Array<any>).map(
      InstructionCardFromJSON
    ),
  }
}

export function GetInstructions200ResponseDataToJSON(
  value?: GetInstructions200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    instructions: (value['instructions'] as Array<any>).map(
      InstructionCardToJSON
    ),
  }
}
